module.exports = __webpack_public_path__ + "img/kh26.9ad1da21.png";